module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid search selection dropdown",
    attrs: {
      "id": _vm.element_id
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.selection
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v(_vm._s(_vm.default_text))]), _vm._v(" "), _c('div', {
    staticClass: "menu dropdown_menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1cad07d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Dropdown.vue
// module id = 1448
// module chunks = 1